import { useContext } from "react";

import { ChatbotContext } from "./ChatbotProvider";

/** Simple hook to return context value from ChatbotContext, if it exists */

export const useChatbot = () => useContext(ChatbotContext) ?? {};
